import i18n from 'i18n-js';
import * as types from './types';
import { uiActions } from 'state/modules/UI';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import * as reservationsRulesApi from 'services/api/reservationRulesets';

// Get reservations
const fetchReservationRulesetsRequest = () => ({
  type: types.FETCH_RESERVATION_RULESETS_REQUEST,
});

const fetchReservationRulesetsSuccess = (payload) => ({
  type: types.FETCH_RESERVATION_RULESETS_SUCCESS,
  payload,
});

const fetchReservationRulesetsFailed = () => ({
  type: types.FETCH_RESERVATION_RULESETS_FAILED,
});

const fetchReservationRulesets = (params = {}, options) => {
  return async (dispatch) => {
    dispatch(fetchReservationRulesetsRequest());

    const response = await reservationsRulesApi.fetchReservationRulesets(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchReservationRulesetsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchReservationRulesetsFailed());
    }
  };
};

// Get reservations Ruleset by id
const fetchReservationRulesetByIdRequest = () => ({
  type: types.FETCH_RESERVATION_RULESET_BY_ID_REQUEST,
});

const fetchReservationRulesetByIdSuccess = (payload) => ({
  type: types.FETCH_RESERVATION_RULESET_BY_ID_SUCCESS,
  payload,
});

const fetchReservationRulesetByIdFailed = () => ({
  type: types.FETCH_RESERVATION_RULESET_BY_ID_FAILED,
});

const fetchReservationRulesetById = (id) => {
  return async (dispatch) => {
    dispatch(fetchReservationRulesetByIdRequest());

    const response = await reservationsRulesApi.fetchReservationRulesetById(id);

    if (response.ok) {
      return dispatch(
        fetchReservationRulesetByIdSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchReservationRulesetByIdFailed());
  };
};

// Get reservations Ruleset by id
const createReservationRulesetRequest = () => ({
  type: types.CREATE_RESERVATION_RULESET_REQUEST,
});

const createReservationRulesetSuccess = (payload) => ({
  type: types.CREATE_RESERVATION_RULESET_SUCCESS,
  payload,
});

const createReservationRulesetFailed = (payload) => ({
  type: types.CREATE_RESERVATION_RULESET_FAILED,
  payload,
});

export const createReservationRuleset = (params) => {
  return async (dispatch) => {
    dispatch(createReservationRulesetRequest());

    const response = await reservationsRulesApi.createReservationRuleset(params);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reservation_rulesets.create_success'),
        })
      );
      return dispatch(createReservationRulesetSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data);

    if (typeof formattedError === 'string') {
      dispatch(createReservationRulesetFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('reservation_rulesets.create_failure'),
      })
    );

    return dispatch(createReservationRulesetFailed(errors));
  };
};

const updateReservationRulesetRequest = () => ({
  type: types.UPDATE_RESERVATION_RULESET_REQUEST,
});

const updateReservationRulesetSuccess = (payload) => ({
  type: types.UPDATE_RESERVATION_RULESET_SUCCESS,
  payload,
});

const updateReservationRulesetFailed = (payload) => ({
  type: types.UPDATE_RESERVATION_RULESET_FAILED,
  payload,
});

export const updateReservationRuleset = (id, params) => {
  return async (dispatch) => {
    dispatch(updateReservationRulesetRequest());

    const response = await reservationsRulesApi.updateReservationRuleset(id, params);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reservation_rulesets.update_success'),
        })
      );
      return dispatch(updateReservationRulesetSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(updateReservationRulesetFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    const errorMsg =
      getErrorMessage(response.data) || i18n.t('reservation_rulesets.update_failure');

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: errorMsg,
      })
    );

    return dispatch(updateReservationRulesetFailed(errors));
  };
};

const resetCurrentRuleset = () => {
  return async (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_RESERVATION_RULESET,
    });
  };
};

const fetchUpdateReservationRulesetInfoSuccess = (payload) => ({
  type: types.FETCH_UPDATE_RESERVATION_RULESET_INFO_SUCCESS,
  payload,
});

export const fetchUpdateReservationRulesetInfo = (data) => {
  return async (dispatch) => {
    dispatch(fetchUpdateReservationRulesetInfoSuccess(data));
  };
};

const deleteReservationRulesetRequest = () => ({
  type: types.DELETE_RESERVATION_RULESET_REQUEST,
});

const deleteReservationRulesetSuccess = (payload) => ({
  type: types.DELETE_RESERVATION_RULESET_SUCCESS,
  payload,
});

const deleteReservationRulesetFailed = (payload) => ({
  type: types.DELETE_RESERVATION_RULESET_FAILED,
  payload,
});

export const deleteReservationRuleset = (id) => {
  return async (dispatch) => {
    dispatch(deleteReservationRulesetRequest());

    const response = await reservationsRulesApi.deleteReservationRuleset(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('reservation_rulesets.delete_success'),
        })
      );
      return dispatch(deleteReservationRulesetSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(deleteReservationRulesetFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('reservation_rulesets.delete_failure'),
      })
    );

    return dispatch(deleteReservationRulesetFailed(errors));
  };
};

export { fetchReservationRulesets, fetchReservationRulesetById, resetCurrentRuleset };
